import { get } from "lodash";
import AdUnit from "./adUnit";
import DefinitionValue from "./definitionValue";

export class AvailabilityFilterModel {
  site_id?: string[] | string;
  ad_units?: string[] | string;
  start?: Date;
  end?: Date;
  definitions?: string[] | string;
}

export class AvailabilityEvent {
  name?: string;
  start?: Date;
  end?: Date;
  color?: string;
}

export class TimeLineGroup {
  id: string;
  content: string;
  adUnit: AdUnit;
  definitions: DefinitionValue[];

  constructor(params?: TimeLineGroup) {
    this.id = get(params, "id", "");
    this.content = get(params, "content", "");
    this.adUnit = get(params, "adUnit", new AdUnit());
    this.definitions = get(params, "definitions", []);
  }
}

export class TimeLineItem {
  id: string;
  content: string;
  start: string;
  end: string;
  group: string;
  className: string;
  title: string;
  adUnit: AdUnit;

  constructor(params?: TimeLineItem) {
    this.id = get(params, "id", "");
    this.content = get(params, "content", "");
    this.start = get(params, "start", "");
    this.end = get(params, "end", "");
    this.group = get(params, "group", "");
    this.className = get(params, "className", "");
    this.title = get(params, "title", "");
    this.adUnit = get(params, "adUnit", new AdUnit());
  }
}

export class AvailabilityNode {
  id: string;
  name: string;
  type: string;
  children?: AvailabilityNode[];
  status?: string;

  constructor(params?: AvailabilityNode) {
    this.id = get(params, "id", "");
    this.name = get(params, "name", "");
    this.type = get(params, "type", "");
    this.children = get(params, "children", []);
    this.status = get(params, "status", "active");
    // if (get(params, "children", undefined)) {
    //   this.children = get(params, "children", undefined);
    // }
  }
}
